import './../app/shared/operators';
import { of } from 'rxjs/observable/of';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/from';

import { Action } from '@ngrx/store';
import { Effect, Actions } from '@ngrx/effects';

import * as a from '../actions/app.actions';

import { Api } from '../providers/api/api';
import { Store } from '@ngrx/store';
import * as fromRoot from '../reducers'


@Injectable()
export class ContactEffects {
  constructor(private actions$: Actions,
    private api: Api,
    private store: Store<fromRoot.State>
  ) {
  }

  @Effect()
  sendContactMessage$: Observable<Action> = this.actions$
    .ofType(a.SEND_CONTACT_MESSAGE)
    .map((action: a.SendContactMessage) => {
      return action.payload;
    })
    .switchMap((payload) => Observable.from(
      this.api.sendContactMessage(payload))

    .map(res => {
      return new a.SendContactMessageSuccess(res);
    }).catch((err) => of(new a.SendContactMessageFailure(err))));

}



// WEBPACK FOOTER //
// ./src/effects/contact.effects.ts